const backendErrorTranslations = {
  "Email has already been taken": "El correo electrónico ya está en uso.",
  "Id document has already been taken": "El número de identificación ya está en uso.",
  "Phone number has already been taken": "El número de teléfono ya está en uso.",
};

export const parseBackendErrorMessage = (input) => {
  if (!input) return "Ocurrió un error inesperado.";

  let message = input;

  if (typeof message === "object" && !Array.isArray(message)) {
    if (message.message) message = message.message;
    else if (message.error) message = message.error;
    else message = JSON.stringify(message);
  }

  if (Array.isArray(message)) {
    return message
      .map((err) => {
        const m = err?.message ?? String(err);
        return backendErrorTranslations[m] || m;
      })
      .join(" ");
  }

  const msgStr = String(message);
  const cleaned = msgStr.replace(/^Validation failed:\s*/, "");
  const parts = cleaned.split(", ");

  const translated = parts.map((part) => backendErrorTranslations[part.trim()] || part.trim()).join(" ");

  return translated || "Ocurrió un error inesperado.";
};
